import { TaskTimelineFrameEnum } from 'graphql-common';

export function getTaskTimelineViewOptions() {
  return [
    {
      value: TaskTimelineFrameEnum.Week,
      labelKey: 'week',
    },
    {
      value: TaskTimelineFrameEnum.Month,
      labelKey: 'month',
    },
    {
      value: TaskTimelineFrameEnum.Quarter,
      labelKey: 'quarter',
    },
    {
      value: TaskTimelineFrameEnum.Year,
      labelKey: 'year',
    },
  ];
}

export function getTaskTimelineViewOption(value: TaskTimelineFrameEnum) {
  const options = getTaskTimelineViewOptions();
  return options.find((opt) => opt.value === value);
}
